import React from "react";

class Footer extends React.Component {
    render() {
        return (
            <>
                <footer className='bg-dark' id='tempaltemo_footer'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-md-5 pt-5 '>
                                <h1 className='sabz-footer'>SabZ</h1>
                                <ul className='list-unstyled text-light footer-link-list'>
                                    <li>
                                        <i className='fas fa-map-marker-alt fa-fw'></i>
                                        <a
                                            className='text-decoration-none'
                                            href='https://www.google.com/maps/place/Sripuram,+B+N+Reddy+Nagar,+Hyderabad,+Telangana/@17.2964112,78.5463355,11.96z/data=!4m5!3m4!1s0x3bcba2224a523487:0x9a411023e840de27!8m2!3d17.3129503!4d78.5580477'>
                                            Plot No. 351, Teachers colony, Saroor Nagar, Hyderabad,Telangana{' '}
                                        </a>
                                    </li>
                                    <li>
                                        <i className='fa fa-phone fa-fw'></i>
                                        <a
                                            className='text-decoration-none'
                                            href='tel:+91 7382200558 '>
                                            +91 7382200558{' '}
                                        </a>
                                    </li>
                                    <li>
                                        <i className='fa fa-envelope fa-fw'></i>
                                        <a
                                            className='text-decoration-none'
                                            href='mailto:SabZ@gmail.com'>
                                            {' '}
                                            director@sabzonline.in{' '}
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            <div className='col-md-2 pt-5'>
                                <h3 className='h3 text-light '>More about us </h3>
                                <ul className='list-unstyled text-light footer-link-list'>
                                    <li>
                                        <a className='text-decoration-none' href='/'>
                                            More search{' '}
                                        </a>
                                    </li>
                                    <li>
                                        <a className='text-decoration-none' href='/'>
                                            Blogs
                                        </a>
                                    </li>
                                    <li>
                                        <a className='text-decoration-none' href='/'>
                                            Testimonials{' '}
                                        </a>
                                    </li>
                                    <li>
                                        <a className='text-decoration-none' href='/'>
                                            Events
                                        </a>
                                    </li>
                                    <li>
                                        <a className='text-decoration-none' href='/'>
                                            Shop Locations
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            <div className='col-md-3 pt-5'>
                                <h3 className='h3 text-light '>Connect with us </h3>
                                <ul className='list-unstyled text-light footer-link-list'>
                                    <li>
                                        <a className='text-decoration-none' href='/'>
                                            Twitter{' '}
                                        </a>
                                    </li>
                                    <li>
                                        <a className='text-decoration-none' href='/'>
                                            Facebook
                                        </a>
                                    </li>
                                    <li>
                                        <a className='text-decoration-none' href='/'>
                                            Instagram
                                        </a>
                                    </li>
                                    <li>
                                        <a className='text-decoration-none' href='/'>
                                            Linkedin
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            <div className='col-md-2 pt-5'>
                                <ul className='list-unstyled text-light footer-link-list'>
                                    <li>
                                        <a
                                            className='  text-light text-decoration-none'
                                            href='/privacy_policy'>
                                            Privacy Policy
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className='  text-light text-decoration-none'
                                            href='/refund_policy'>
                                            Refund policy
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className=' text-light text-decoration-none'
                                            href='/terms_conditions'>
                                            Terms and conditions
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className='row text-light mb-4'>
                            <div className='col-12 mb-3'>
                                <div className='w-100 my-3 '></div>
                            </div>
                            <div className='col-auto me-auto'>
                                <ul className='list-inline  text-left footer-icons'>
                                    <li className='list-inline-item border  rounded-circle text-center'>
                                        <a
                                            className='text-light text-decoration-none'
                                            target='_blank'
                                            rel='noopener noreferrer'
                                            href='http://facebook.com/'>
                                            <i className='fab fa-facebook-f fa-lg fa-fw'></i>
                                        </a>
                                    </li>
                                    <li className='list-inline-item border  rounded-circle  text-center'>
                                        <a
                                            className='text-light text-decoration-none'
                                            target='_blank'
                                            rel='noopener noreferrer'
                                            href='https://www.instagram.com/'>
                                            <i className='fab fa-instagram fa-lg fa-fw'></i>
                                        </a>
                                    </li>
                                    <li className='list-inline-item border  rounded-circle text-center'>
                                        <a
                                            className='text-light text-decoration-none'
                                            target='_blank'
                                            rel='noopener noreferrer'
                                            href='https://twitter.com/'>
                                            <i className='fab fa-twitter fa-lg fa-fw'></i>
                                        </a>
                                    </li>
                                    <li className='list-inline-item border  rounded-circle text-center'>
                                        <a
                                            className='text-light text-decoration-none'
                                            target='_blank'
                                            rel='noopener noreferrer'
                                            href='https://www.linkedin.com/'>
                                            <i className='fab fa-linkedin fa-lg fa-fw'></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </footer>
            </>
        )
    }
}


export default Footer